import { PropsWithChildren } from 'react';

import { Gradients } from '@/shared/components/theme/gradient';
import { Table } from '@/shared/components/ui/table';
import { cn } from '@/shared/utils/cn';

type Props = {
  simpleHeader?: string;
  dottedBorder?: boolean;
} & PropsWithChildren;

export const CustomTable = ({
  children,
  simpleHeader,
  dottedBorder = false,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        `${Gradients.transparentWhiteGradient} rounded-md bg-gradient-to-b p-2 backdrop-blur-xl`,
        dottedBorder && 'border border-dashed border-white/15',
      )}
    >
      {simpleHeader && <div className="pb-2 pl-4 text-xs">{simpleHeader}</div>}
      <Table className="space-y-2">{children}</Table>
    </div>
  );
};
